/* Ginspire Wellness — video.js
   9:16 explainer behavior: muted autoplay on hover (desktop) or in-view (mobile),
   tap-to-unmute, one-at-a-time sound, placeholder-safe. */
(function () {
  const cfg = window.GW_VIDEO || { hover: true, inview: true };
  const isTouch = window.matchMedia('(hover: none)').matches;
  const videos = Array.from(document.querySelectorAll('.gw-video'));
  let soundOwner = null;

  function el(v) { return v.querySelector('video'); }

  function play(wrapper) {
    const v = el(wrapper);
    if (!v) return;
    v.muted = wrapper !== soundOwner;
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
    wrapper.classList.add('is-playing');
  }
  function pause(wrapper) {
    const v = el(wrapper);
    if (!v) return;
    v.pause();
    wrapper.classList.remove('is-playing');
  }
  function unmute(wrapper) {
    const v = el(wrapper);
    if (!v) return;
    if (soundOwner && soundOwner !== wrapper) {
      el(soundOwner).muted = true;
      soundOwner.classList.remove('is-unmuted');
    }
    soundOwner = wrapper;
    v.muted = false;
    wrapper.classList.add('is-unmuted');
    play(wrapper);
  }
  function mute(wrapper) {
    const v = el(wrapper);
    if (!v) return;
    v.muted = true;
    wrapper.classList.remove('is-unmuted');
    if (soundOwner === wrapper) soundOwner = null;
  }

  videos.forEach((w) => {
    const v = el(w);
    const playBtn = w.querySelector('.gw-video__play');
    const muteBtn = w.querySelector('.gw-video__mute');
    if (!v) return; // placeholder: nothing to wire

    v.setAttribute('playsinline', '');
    v.muted = true;
    v.loop = true;

    if (cfg.hover && !isTouch) {
      w.addEventListener('mouseenter', () => play(w));
      w.addEventListener('mouseleave', () => { if (soundOwner !== w) pause(w); });
    }
    if (playBtn) {
      playBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); unmute(w); });
    }
    if (muteBtn) {
      muteBtn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (w.classList.contains('is-unmuted')) mute(w); else unmute(w);
      });
    }
    // Tap anywhere on the video on touch devices toggles sound
    if (isTouch) {
      v.addEventListener('click', (e) => {
        e.preventDefault();
        if (w.classList.contains('is-unmuted')) mute(w); else unmute(w);
      });
    }
  });

  if (cfg.inview && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const w = entry.target;
        if (!el(w)) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          if (isTouch || w.hasAttribute('data-autoplay')) play(w);
        } else if (!entry.isIntersecting) {
          pause(w);
          if (soundOwner === w) mute(w);
        }
      });
    }, { threshold: [0, 0.6] });
    videos.forEach((w) => io.observe(w));
  }

  // Product media rail: switch stage items
  document.querySelectorAll('[data-media-rail]').forEach((rail) => {
    const stage = document.querySelector(rail.getAttribute('data-media-rail'));
    if (!stage) return;
    rail.querySelectorAll('[data-media-target]').forEach((btn) => {
      btn.addEventListener('click', () => {
        rail.querySelectorAll('[data-media-target]').forEach((b) => b.removeAttribute('aria-current'));
        btn.setAttribute('aria-current', 'true');
        stage.querySelectorAll('.stage__item').forEach((item) => {
          const active = item.getAttribute('data-media-id') === btn.getAttribute('data-media-target');
          if (active) item.setAttribute('data-active', ''); else item.removeAttribute('data-active');
          const w = item.querySelector('.gw-video');
          if (w) { if (active) play(w); else pause(w); }
        });
      });
    });
  });
})();
